// @ts-nocheck
import { useState, useEffect } from "react"
import SEOHead from "../components/head"
import { graphql, Slice } from "gatsby"
import { Box, Fab, Zoom } from "@mui/material"
import { get } from "lodash"
import { useDispatch, addNode, removeNode, useSelector } from "@ggs/store"
import readingTime from "reading-time/lib/reading-time"
import Layout from "../components/layout"
import { useArticlesSolrData } from "../local/hooks"
import { mapArticleData, mapWishlistData, mapArticleTeaser } from "../helpers/data-mappers"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"

// article page components
import { ArticleBody, AuthorPreview, Hero3, Teaser } from "../components"

/**
 * Article detail view page template.
 */
export default function ArticleView(props) {
  const article = get(props, "data.nodeArticle", {})
  const wishlist = useSelector((state) => state.views.wishlist)
  const likedArticles = wishlist?.article && wishlist?.article.map((article) => article.nid)
  const dispatch = useDispatch()
  const { getArticles } = useArticlesSolrData()
  const [articleTeasers, setArticleTeasers] = useState([])
  const [isArticleLiked, setIsArticleLiked] = useState(
    (likedArticles && likedArticles.includes(article.external_id)) || false
  )
  const countryId = article?.country?.[0]?.external_id || null
  const destinationId = article?.destinations?.[0]?.external_id || null

  //Back to top button

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight + 100)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  // Resolve Solr data.
  useEffect(() => {
    getArticles(null, countryId, destinationId).then((data) => {
      const filteredData = mapWishlistData(likedArticles, data)
      setArticleTeasers(filteredData)
    })
  }, [])

  const addToWishList = (selectedEntity) => {
    const filteredState = mapArticleTeaser(articleTeasers, selectedEntity, true)
    setArticleTeasers(filteredState)
    dispatch(addNode({ type: "article", entity: selectedEntity, idPropertyKey: "nid" }))
  }

  const removeFromWishList = (selectedEntity) => {
    const filteredState = mapArticleTeaser(articleTeasers, selectedEntity, false)
    setArticleTeasers(filteredState)
    dispatch(removeNode({ type: "article", findPredicate: selectedEntity }))
  }

  const addToWishListHero = () => {
    setIsArticleLiked(true)
    dispatch(
      addNode({
        type: "article",
        entity: { contentType: "article", nid: article.external_id },
        idPropertyKey: "nid",
      })
    )
  }

  const removeFromWishListHero = () => {
    setIsArticleLiked(false)
    dispatch(
      removeNode({
        type: "article",
        findPredicate: { contentType: "article", nid: article.external_id },
      })
    )
  }

  if (!article) {
    return <Box>{t("Article not found")}</Box>
  }
  const duration = readingTime(article?.body || "")

  const mappedArticle = mapArticleData(article)

  const { article_category, image, location, body, tags, author, shareLinks, published } =
    mappedArticle

  const isArticleCategory = Array.isArray(article_category) && article_category.length > 0
  const path = [
    { title: "Home", uri: "/" },
    { title: "Inspiration", uri: "/inspiration" },
    ...(isArticleCategory
      ? [{ title: article_category[0]?.title, uri: article_category[0]?.uri }]
      : []),
    { title: article?.title },
  ]

  return (
    <>
      {ComposeHead(props)}
      <Layout
        hero={
          <Hero3
            title={article?.title}
            image={image}
            location={location}
            tags={article_category}
            duration={duration?.text}
            path={path}
            date={published}
            onLike={addToWishListHero}
            onUnlike={removeFromWishListHero}
            isArticleLiked={isArticleLiked}
          />
        }
      >
        <AuthorPreview {...author} />
        <ArticleBody description={body} author={author} tags={tags} shareLinks={shareLinks} />
        {articleTeasers && (
          <Teaser
            title="Travel Stories to Inspire You."
            subtitle="Get Inspired"
            link={{ title: "Travel Inspiration", uri: "/inspiration" }}
            items={articleTeasers}
            onLike={addToWishList}
            onUnlike={removeFromWishList}
          />
        )}
        <Zoom in={visible}>
          <Fab
            color="primary"
            size="large"
            onClick={handleClick}
            sx={{
              position: "fixed",
              bottom: "20px",
              left: "20px",
              transform: "translateY(-50%)",
              zIndex: 1200,
              boxShadow: 3,
            }}
            aria-label="Back to top"
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>
        <Slice alias="preFooterStyle3" />
      </Layout>
    </>
  )
}
export const ComposeHead = (props) => {
  const { nodeArticle } = props.data
  const metatag = get(nodeArticle, "metatag.items")
  const url = get(nodeArticle, "slug")
  const image = get(nodeArticle, "featured_images[0].variants[0].url")
  return <SEOHead metas={metatag} url={url} image={image} type="article" />
}

export const query = graphql`
  query ($id: String!) {
    nodeArticle(id: { eq: $id }) {
      id
      external_id
      slug
      title
      body
      created
      metatag {
        items {
          name
          content
        }
      }
      article_type {
        title
        external_id
        slug
        link: self_link {
          title
          uri
        }
      }
      authored_by {
        title
        external_id
        description
        position
        photo {
          variants {
            url
            title
            style
            width
            height
          }
        }
        link: self_link {
          title
          uri
        }
      }
      article_category {
        title
        external_id
        slug
      }
      featured_images {
        variants {
          url
          title
          style
          width
          height
          alt
        }
      }
      country {
        title
        external_id
        slug
      }
      destinations {
        title
        external_id
        slug
      }
    }
  }
`
